/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Manage_Contract_No_PrepaidInputs */



/**
* | output |
* | --- |
* | "No prepaid usage — seats only" |
*
* @param {Partner_Manage_Contract_No_PrepaidInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_manage_contract_no_prepaid = /** @type {((inputs?: Partner_Manage_Contract_No_PrepaidInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Manage_Contract_No_PrepaidInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine vorausbezahlte Nutzung — nur Plätze")
	return /** @type {LocalizedString} */ ("No prepaid usage — seats only")
});